import { FC } from "react";
import CloseButton from "@/components/ui/close-button";
import Modal from "@/components/entities/modal";
import CustomIcon from "@/components/ui/custom-icon";
import S from "./index.module.scss";

interface IQuestionModal {
  onClose(): void;
}

const QuestionModal: FC<IQuestionModal> = ({ onClose }) => {
  return (
    <Modal onClose={onClose}>
      <div className={S.content}>
        <CloseButton onClose={onClose} />
        <h3 className={S.title}>Поставити питання</h3>
        <div className={S.contactWrapper}>
          <div className={S.contactItem}>
            <p className={S.contactTitle}>Viber</p>
            <a className={S.contactPhone} href="viber://chat?number=%2B0634456214">
              (063) 445 62 14
            </a>
          </div>
          <div className={S.contactItem}>
            <p className={S.contactTitle}>
              <CustomIcon fileName="icon-phone" />
            </p>
            <a className={S.contactPhone} href="tel:(063) 445 62 14">
              (063) 445 62 14 <span className={S.contactDescription}>з 09:00 до 20:00</span>
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default QuestionModal;
